import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { subscriptionsApi } from '@urc-ui/store/api/subscriptions/subscriptions';
import { reportMetadataApi } from '@urc-ui/store/api/report-metadata/reportMetadata';
import { reportsApi } from '@urc-ui/store/api/reports/reports';
import { advertiserInfoApi } from '@urc-ui/store/api/advertisers/advertisers';
import { userPreferencesApi } from '@urc-ui/store/api/user-preferences/userPreferences';
import { rossSubscriptionsApi } from '@urc-ui/store/api/ross/subscriptions/subscriptions';
import { rossReportsApi } from '@urc-ui/store/api/ross/reports/reports';
import subscriptionsDataTableReducer from '@urc-ui/store/slices/landing/subscriptionsDataTableSlice';
import reportsDataTableReducer from '@urc-ui/store/slices/view-subscription/reportsDataTableSlice';
import CreateSubscriptionReducer from '@urc-ui/store/slices/create-subscription/createSubscriptionSlice';
import snackbarReducer from '@urc-ui/store/slices/snackbar/snackbarSlice';
import EditReportSettingsReducer from './slices/view-subscription/edit-report-settings-slice';

export const rootReducer = combineReducers({
  [subscriptionsApi.reducerPath]: subscriptionsApi.reducer,
  [reportMetadataApi.reducerPath]: reportMetadataApi.reducer,
  [reportsApi.reducerPath]: reportsApi.reducer,
  [advertiserInfoApi.reducerPath]: advertiserInfoApi.reducer,
  [userPreferencesApi.reducerPath]: userPreferencesApi.reducer,
  [rossSubscriptionsApi.reducerPath]: rossSubscriptionsApi.reducer,
  [rossReportsApi.reducerPath]: rossReportsApi.reducer,
  subscriptionsDataTable: subscriptionsDataTableReducer,
  reportsDataTable: reportsDataTableReducer,
  editReportSettings: EditReportSettingsReducer,
  createSubscription: CreateSubscriptionReducer,
  snackbarMessages: snackbarReducer
});

const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware()
      .concat(subscriptionsApi.middleware)
      .concat(reportMetadataApi.middleware)
      .concat(reportsApi.middleware)
      .concat(advertiserInfoApi.middleware)
      .concat(userPreferencesApi.middleware)
      .concat(rossSubscriptionsApi.middleware)
      .concat(rossReportsApi.middleware)
});

export default store;
